<template>
  <div style="padding: 30px; background-color: #fbf9f6; height: 100vh">
    <img
      :src="MobileSplash"
      width="100%"
    >
    <div style="font-family: 'Helvetica'; margin-top: 20px; font-weight: 700; font-size: 20px; text-align: center">
      Mobile App Download
    </div>
    <div
      style="font-family: 'Helvetica'; font-size: 20px; font-weight: 400; margin: 10px 30px 30px 30px; text-align: center"
    >
      We are working hard to bring you an improved mobile web experience. In the
      meantime, please use our mobile app or visit our dashboard from your desktop or
      tablet.
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-around">
      <a
        href="https://itunes.apple.com/us/app/noiseaware/id1436213179?ls=1&mt=8"
        rel="noopener noreferrer"
        target="_blank"
        style="width: 70px; height: auto; flex: auto; max-width: 256px; margin-right: 18px"
      >
        <img
          :src="AppleStoreButton"
          style="width: 100%"
        >
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=io.noiseaware.mobile&hl=en"
        rel="noopener noreferrer"
        target="_blank"
        style="width: 70px; height: auto; flex: auto; max-width: 256px"
      >
        <img
          :src="GooglePlayButton"
          style="width: 100%"
        >
      </a>
    </div>
  </div>
</template>

<script>
  import MobileSplash from '@/assets/mobile-splash.png'
  import GooglePlayButton from '@/assets/NoiseAware_GooglePlayStore.png'
  import AppleStoreButton from '@/assets/NoiseAware_AppleAppStore.png'
  export default {
    name: 'MobilePlaceholder',
    computed: {
      MobileSplash () {
        return MobileSplash
      },
      GooglePlayButton () {
        return GooglePlayButton
      },
      AppleStoreButton () {
        return AppleStoreButton
      },
    },
  }
</script>
